import { createContext } from "react";

// Filled by I18nProvider. Default keeps consumers safe if used unwrapped.
const I18nContext = createContext({
  lang: "he",
  dir: "rtl",
  setLang: () => {},
  toggle: () => {},
  t: (key) => key,
});

export default I18nContext;
